// src/components/SelectTramoDialog.tsx
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Tramo } from '../hooks/useVacaciones';

export interface SelectTramoDialogProps {
  open: boolean;
  initial: Tramo;
  onCancel: () => void;
  onConfirm: (tramo: Tramo) => void;
}

/**
 * Diálogo para elegir «mañana / tarde / completo».
 * El profesor selecciona el tramo y, al pulsar **Guardar**, se envía la solicitud.
 */
export default function SelectTramoDialog({
  open,
  initial,
  onCancel,
  onConfirm,
}: SelectTramoDialogProps) {
  const [value, setValue] = useState<Tramo>(initial);

  /* Resetea el valor cuando se abre con un initial distinto */
  useEffect(() => {
    if (open) setValue(initial);
  }, [open, initial]);

  const handleSave = () => {
    onConfirm(value); // envía el tramo elegido
    onCancel(); // cierra el diálogo
  };

  const { t } = useTranslation<'translation'>();

  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{t('selectTramoDialog.title')}</DialogTitle>

      <DialogContent sx={{ pt: 1 }}>
        <RadioGroup value={value} onChange={(_, v) => setValue(v as Tramo)}>
          <FormControlLabel
            value="manana"
            control={<Radio />}
            label={t('selectTramoDialog.manana')}
          />
          <FormControlLabel
            value="tarde"
            control={<Radio />}
            label={t('selectTramoDialog.tarde')}
          />
          <FormControlLabel
            value="completo"
            control={<Radio />}
            label={t('selectTramoDialog.completo')}
          />
        </RadioGroup>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel}>{t('common.cancel')}</Button>
        <Button variant="contained" onClick={handleSave}>
          {t('common.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
